import React from 'react';
import { batch, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import TV from '../../../../shared/images/TV.svg';
import {
  setActiveModal,
  setIsPrimaryAnimatedSideBarOpen,
  setIsTvMode,
  // toggleAnalyticsStrikethrough,
} from '../../ducks/calendarActions';

const IconButtonsWrapper = styled('div')`
  display: flex;
  gap: 10px;
  align-items: center;
`;

/* TV mode has no phone use; Settings does (Appearance and the transposed-table
   switch), so only TV mode hides at phone width. */
const PhoneHidden = styled('div')`
  display: contents;
  @media screen and (max-width: 570px) {
    display: none;
  }
`;

const IconWrapperStyle = styled('div')`
  cursor: pointer;
  transition: all 250ms ease-in-out;
  :hover {
    opacity: 0.7;
  }
`;

const BorderedIconWrapper = styled(IconWrapperStyle)`
  background-color: ${({ theme }) => theme.colors.buttonBackground};
  border: 1px solid ${({ theme }) => theme.colors.borderButton};
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 3px 0px #3031331A;
  /* The header's Today button and view picker drop to 30px at tablet width and
     28px on phones; the padding around the 20px icon (plus the 1px border)
     tracks those heights. */
  @media screen and (max-width: 773px) {
    padding: 4px;
  }
  @media screen and (max-width: 570px) {
    padding: 3px;
  }
`;

// Used only by the stats-bar button, which now lives in Settings → General.
// const AnalyticsIconContainer = styled('div')`
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

const TVIcon = styled('div')`
  height: 20px;
  width: 20px;
  background-image: url(${TV});
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  /** TV.svg is solid black; tint it to #9E9E9E to match the trending-up
   *  and gear icons sitting next to it. invert(62%) maps black → ~#9E9E9E. */
  filter: invert(62%);
`;

// const StrikeThrough = styled('div')`
//   position: absolute;
//   width: 100%;
//   height: 3px;
//   background-color: ${({ theme }) => theme.colors.textSecondary};
//   top: 50%;
//   transform: translateY(-50%) rotate(45deg);
//   transition: opacity 0.3s ease;
//   opacity: ${(props) => (props.visible ? 1 : 0)};
// `;

const GearIconButtons = () => {
  const dispatch = useDispatch();
  // const isAnalyticsDisabled = useSelector(
  //   (state) => state.calendar.ui.isAnalyticsDisabled,
  // );

  // Generate unique ID for tooltip
  // const analyticsTooltipId = 'analytics-tooltip';
  const tvModeTooltipId = 'tv-mode-tooltip';
  const settingsTooltipId = 'settings-tooltip';

  const handleOpenSettings = () => {
    dispatch(setActiveModal('settingsModal'));
  };

  // const handleToggleAnalytics = () => {
  //   dispatch(toggleAnalyticsStrikethrough());
  // };

  const { colors } = useTheme();
  const handleEnterTvMode = () => {
    batch(() => {
      dispatch(setIsTvMode(true));
      dispatch(setIsPrimaryAnimatedSideBarOpen(false));
    });
  };

  return (
    <IconButtonsWrapper>
      <PhoneHidden>
        <BorderedIconWrapper
          onClick={handleEnterTvMode}
          data-tooltip-id={tvModeTooltipId}
          aria-label='Enter TV Mode'
        >
          <TVIcon />
        </BorderedIconWrapper>
        {/* Stats bar visibility moved to Settings → General. Restore by uncommenting
            this button, its tooltip below, and the supporting code above.
        <BorderedIconWrapper
          onClick={handleToggleAnalytics}
          data-tooltip-id={analyticsTooltipId}
        >
          <AnalyticsIconContainer>
            <IcomoonReact
              iconSet={iconSet}
              size={20}
              icon='trending-up'
              color={colors.textSecondary}
            />
            <StrikeThrough visible={isAnalyticsDisabled} />
          </AnalyticsIconContainer>
        </BorderedIconWrapper>
        */}
      </PhoneHidden>
      <BorderedIconWrapper
        onClick={handleOpenSettings}
        data-tooltip-id={settingsTooltipId}
        aria-label='Settings'
      >
        <IcomoonReact
          iconSet={iconSet}
          size={20}
          icon='gear'
          color={colors.textSecondary}
        />
      </BorderedIconWrapper>
      {/* ReactTooltip components */}
      {/*
      <ReactTooltip
        id={analyticsTooltipId}
        place='left'
        content={isAnalyticsDisabled ? 'Show Stats Bar' : 'Hide Stats Bar'}
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: colors.white,
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />
      */}
      <ReactTooltip
        id={tvModeTooltipId}
        place='left'
        content='Enter TV Mode'
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />
      <ReactTooltip
        id={settingsTooltipId}
        place='left'
        content='Settings'
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />
    </IconButtonsWrapper>
  );
};

export default GearIconButtons;
